import api from "../../api/api";

// Telefon raqam bilan login boshlash
export const loginWithPhone = async (phone: string) => {
  const response = await api.post('/users/auth/', {
    phone_number: phone,
  });
  return response.data;
};

// Kod orqali tasdiqlash
export const verifyCode = async (code: string, userId: string) => {
  const response = await api.post('/users/verify/', {
    code: code,
    user: userId,
  });
  return response.data;
};

export const codeResend = async (phone: string) => {
  const response = await api.post('/users/auth/resend/', {
    phone_number: phone,
  });
  return response.data;
};
